var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 453,
    height: 820,
    viewBox: "0 0 453 820",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_7372_2347)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.0268,
    cy: 331,
    rx: 263.027,
    ry: 331,
    fill: "#4745B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7372_2347",
    x: -388.619,
    y: -157.619,
    width: 841.293,
    height: 977.238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 78.8095,
    result: "effect1_foregroundBlur_7372_2347"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseBg);
export default __webpack_public_path__ + "static/media/ellipse-bg.7768c972ae749c5896c264db0208f397.svg";
export { ForwardRef as ReactComponent };